<div class="container-fluid p-0">
  <div class="d-flex flex-row mw-100">
    <div class="col-auto px-0 d-flex align-content-center">
      <button class="btn btn-outline text-primary h1 m-0" (click)="previous('month')"><i
        class="fa-light fa-angle-left"></i></button>
    </div>
    <div class="row m-0 col flex-md-nowrap header-select align-items-stretch">
      @for (c of calendar | keyvalue : sortCalendar; track c) {
        <div
          class="col p-1 text-center d-flex flex-row align-items-center">
          <span class="w-100">{{ c.value.month }} {{ c.value.year }}</span>
        </div>
      }
    </div>
    <div class="col-auto px-0 d-flex align-content-center">
      <button class="btn btn-outline text-primary h1 m-0" (click)="next('month')"><i
        class="fa-light fa-angle-right"></i></button>
    </div>
  </div>
  <div class="row m-0 flex-nowrap">
    @for (c of calendar | keyvalue : sortCalendar; track c) {
      <div style="min-width: 224px;" class="col px-0">
        <div class="row g-0 fw-bolder mb-2" style="height: 2rem">
          @for (day of days; track day) {
            <div class="col d-flex align-items-center justify-content-center">
              <span>{{ day }}</span>
            </div>
          }
        </div>
        <div>
          @for (w of c.value.weeks | keyvalue; track w) {
            <div class="row g-0 align-items-center">
              @for (d of w.value.days; track d) {
                <button class="col day-cell btn btn-light p-0 m-0 border-0" [disabled]="d.disabled"
                        [ngClass]="d.cssClassesButton" (click)="changeDate(d.date)"
                        [appAutoFocus]="isSelectedDate(d.date)" (mouseenter)="cellMouseEnter(d)"
                        (keyup)="onKeyDown($event)" style="width: 2rem; height: 2rem">
                  <div [ngClass]="d.cssClassesBackground" class="d-flex justify-content-center" [style]="d.styles">
                    <span class="d-inline-flex align-self-center">{{ d.date.date() }}</span>
                  </div>
                </button>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
